import { createSelector } from 'reselect';

import { IBaseService } from '~/src/features/managementAgreement/SuspendServices/store/types';

export const getServicesBySuspendStatus = createSelector(
    [
        (services: IBaseService[]) => services,
        (_: IBaseService[], suspendStatus: boolean) => suspendStatus,
    ],
    (services, suspendStatus) => services.filter(el => el.isSuspended === suspendStatus),
);
